var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"center"},[_c('router-link',{staticClass:"logo-row",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../assets/images/logo-small.png")}}),_vm._v("十方实验室 ")]),_c('router-view')],1),_c('indexFooter',{attrs:{"position":'fixed'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }